<div class="page-container">
  <div class="top-toolbar">
    <div class="sub-title">SETTINGS</div>
    <div class="title">Integrations</div>
  </div>

  <div class="integration-item__header line-height-24 u-font-size-20">
    External API Access Key
  </div>
  <span class="integration-item__subheader">
    <a href="https://helpcenter.inscyd.com/en/articles/10205759-integrations" target="_blank">
      Helpdesk
    </a>
  </span>

  <div class="integration-item__general-info border-color u-margin-top-20 u-margin-bottom-8">
    <div class="integration-item__title position-absolute u-font-weight-400 u-font-size-small line-height-16">API Key</div>
    <div class="integration-item__key position-absolute u-font-weight-400 u-font-size-16 line-height-24">{{integrationObject.key}}</div>
  </div>
  <button class="integration-button integration-item__float-right" mat-raised-button color="primary" (click)="copyApiKey()">Copy API key</button>

  <div *ngIf="showAPIKeys()">
    <ng-container *ngIf="integrationObject.key; else noApiKey">
      <app-integration-item [config]="integrationObject" [apiInfo]="apiInfo"></app-integration-item>
    </ng-container>
    <ng-template #noApiKey>
      <div class="u-text-align-center">
        There is no API Key
      </div>
    </ng-template>
  </div>

  <div *ngIf="showIntegration('nova')">
    <app-integration-nova />
  </div>

  <div *ngIf="showIntegration('vqv')">
    <app-integration-vqv
      [template]="getIntegrationTemplate('vqv')"
      [integration]="getIntegrationForTemplate('vqv')"
    ></app-integration-vqv>
  </div>

  <div *ngIf="showIntegration('cardioworld')">
    <app-integration-cardioworld
      [template]="getIntegrationTemplate('cardioworld')"
      [integration]="getIntegrationForTemplate('cardioworld')"
    ></app-integration-cardioworld>
  </div>
</div>